import mergeDeep from '../../utils/mergeDeep.js'
export default {
  SET_I18N_GROUPS (state, groups) {
    state.i18nGroups = groups
  },
  SET_I18N_VALUES (state, values) {
    state.i18nValues = values
  },
  SET_I18N_LANGUAGES (state, languages) {
    state.i18nLanguages = languages
  },
  SET_I18N (state, i18n) {
    state.i18n = i18n
  },
  ADD_I18N_MESSAGES (state, messages) {
    state.i18nMessages = mergeDeep(state.i18nMessages, messages)
    state.i18n.setLocaleMessage(state.i18n.locale, state.i18nMessages)
  }
}
